import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './tire-truck-implement.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const TireTruckImplementDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireTruckImplementEntity = useAppSelector(state => state.tireTruckImplement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tireTruckImplementDetailsHeading">
          <Translate contentKey="fleetSenseApp.tireTruckImplement.detail.title">TireTruckImplement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tireTruckImplementEntity.id}</dd>
          <dt>
            <span id="installVehicleOdometer">
              <Translate contentKey="fleetSenseApp.tireTruckImplement.installVehicleOdometer">Install Vehicle Odometer</Translate>
            </span>
          </dt>
          <dd>{tireTruckImplementEntity.installVehicleOdometer}</dd>
          <dt>
            <span id="installTireOdometer">
              <Translate contentKey="fleetSenseApp.tireTruckImplement.installTireOdometer">Install Tire Odometer</Translate>
            </span>
          </dt>
          <dd>{tireTruckImplementEntity.installTireOdometer}</dd>
          <dt>
            <span id="position">
              <Translate contentKey="fleetSenseApp.tireTruckImplement.position">Position</Translate>
            </span>
          </dt>
          <dd>{tireTruckImplementEntity.position}</dd>
          <dt>
            <span id="steppe">
              <Translate contentKey="fleetSenseApp.tireTruckImplement.steppe">Steppe</Translate>
            </span>
          </dt>
          <dd>{tireTruckImplementEntity.steppe ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTruckImplement.tire">Tire</Translate>
          </dt>
          <dd>{tireTruckImplementEntity.tire ? tireTruckImplementEntity.tire.identificationCode : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTruckImplement.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{tireTruckImplementEntity.truckImplement ? tireTruckImplementEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTruckImplement.company">Company</Translate>
          </dt>
          <dd>{tireTruckImplementEntity.company ? tireTruckImplementEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/tire-truck-implement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tire-truck-implement/${tireTruckImplementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TireTruckImplementDetail;
